export const BOOST_BUNDLE_DISCOUNT_FEATURE_TOGGLE_ENABLED = false;

export const getBoostBundlePrices = ({
  isLus,
}: {
  isLus: boolean;
}): {
  original: number;
  discount: number;
  savings: number;
  discountedSearchBoost: number;
} => {
  const lusBundle = {
    original: 650_00,
    discount: 450_00,
    discountedSearchBoost: 200_00,
  };
  const adPackBundle = {
    original: 450_00,
    discount: 350_00,
    discountedSearchBoost: 200_00,
  };

  return isLus
    ? {
        ...lusBundle,
        savings: lusBundle.original - lusBundle.discount,
      }
    : {
        ...adPackBundle,
        savings: adPackBundle.original - adPackBundle.discount,
      };
};
